<template>
  <v-row justify="space-around">
    <v-col cols="auto">
      <v-dialog
        v-model="showModalDelete"
        transition="dialog-bottom-transition"
        max-width="500"
        persistent
      >
        <template>
          <v-card>
            <v-card-title> Atenção </v-card-title>
            <v-card-text>
              <div class="text-h6">
                {{ textModalDelete }}
              </div>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn @click="emitCloseModalDelete" text>Fechar</v-btn>
              <v-btn @click="emitResponseModalDelete" class="red--text" text>{{buttomTextModalDelete}}</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    showModalDelete: Boolean,
    textModalDelete: String,
    buttomTextModalDelete: String,
  },

  methods: {
    emitResponseModalDelete() {
      this.$emit("on-response-modal-delete");
    },

    emitCloseModalDelete() {
      this.$emit("close-modal");
    },  
  },
};
</script>